export default __webpack_public_path__ + "static/media/graz1_light.ba3fa0b2.png";